module.exports = __webpack_public_path__ + "img/Steal Smoked Fish.70449a5d.jpg";